import { postRequest } from '@/core';
import { subOrders } from '@/requests';

export default async function getSubOrdersByOrderIdsRequest(idList, filter) {
	let url = subOrders.getMultipleByOrderIdsPath();
	let response = await postRequest(url, {}, { idList, ...filter });
	return response;
}
